/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import axios from 'axios'

/**
 * Shared axios instance for all generated SDK requests.
 * The baseURL is set from the OpenAPI spec. Override at runtime if needed.
 */
export const axiosInstance = axios.create({
	adapter: 'fetch',
	baseURL: 'http://localhost:8088/v1',
	responseType: 'json',
	headers: {
		'Accept': 'application/json',
	},
})
